/**
 * 유해차단 운영보고서 관리 폼의 기본 기간(period) 계산.
 *
 * 운영보고서는 "직전월 데이터를 당월에 업로드/작성"하는 업무이므로,
 * 폼 기본값은 당월(new Date)이 아니라 **직전월**이어야 한다.
 * (당월을 기본값으로 두면 담당자가 값을 고치지 않고 업로드했을 때
 *  6월 데이터에 202607이 붙는 등 period가 한 달 밀린다.)
 *
 * 백엔드 `computeLastMonthPeriod()`와 동일한 규칙.
 *
 * @param now 기준 시각 (기본: 현재 시각) — 테스트 주입용
 * @returns 직전월 YYYYMM 문자열
 */
export function getPreviousMonthPeriod(now: Date = new Date()): string {
  const d = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}`;
}
